import { Link } from "react-router-dom";
import { assetUrl } from "@/lib/api";

const CAT_NAMES = {
  politics: "రాజకీయం",
  district: "జిల్లా వార్తలు",
  agriculture: "వ్యవసాయం",
  crime: "క్రైమ్",
  cinema: "సినిమా/వినోదం",
  special: "ప్రత్యేక కథనాలు",
};

const FALLBACK = {
  politics: "https://images.pexels.com/photos/15774367/pexels-photo-15774367.png?auto=compress&cs=tinysrgb&h=650&w=940",
  agriculture: "https://images.pexels.com/photos/18620458/pexels-photo-18620458.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  cinema: "https://images.pexels.com/photos/14746411/pexels-photo-14746411.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  district: "https://images.pexels.com/photos/13746639/pexels-photo-13746639.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  crime: "https://images.pexels.com/photos/36946519/pexels-photo-36946519.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
  special: "https://images.pexels.com/photos/20407291/pexels-photo-20407291.jpeg?auto=compress&cs=tinysrgb&h=650&w=940",
};

export function coverFor(article) {
  return article.cover_image ? assetUrl(article.cover_image) : FALLBACK[article.category] || FALLBACK.district;
}

export function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString("te-IN", {
      day: "numeric", month: "short", year: "numeric",
    });
  } catch { return ""; }
}

export default function ArticleCard({ article, variant = "default" }) {
  if (variant === "hero") {
    return (
      <Link
        to={`/article/${article.slug}`}
        className="group block relative overflow-hidden nv-zoom h-full min-h-[420px]"
        data-testid={`article-hero-${article.slug}`}
      >
        <img
          src={coverFor(article)}
          alt={article.title}
          className="absolute inset-0 w-full h-full object-cover"
          draggable={false}
        />
        <div className="absolute inset-0 nv-img-overlay" />
        <div className="absolute inset-0 flex flex-col justify-end p-6 md:p-10 text-white">
          <span className="nv-badge w-fit mb-3" data-testid="hero-category">{CAT_NAMES[article.category]}</span>
          <h2 className="font-heading-te text-3xl md:text-4xl lg:text-5xl font-black leading-tight group-hover:text-[#A5D6A7] transition-colors">
            {article.title}
          </h2>
          {article.summary && (
            <p className="mt-3 font-body-te text-base md:text-lg text-white/85 line-clamp-2 max-w-3xl">
              {article.summary}
            </p>
          )}
          <div className="mt-4 text-xs uppercase tracking-widest text-white/70">
            {formatDate(article.created_at)} · {article.author}
          </div>
        </div>
      </Link>
    );
  }

  if (variant === "list") {
    return (
      <Link
        to={`/article/${article.slug}`}
        className="flex gap-4 py-4 border-b border-[#E5E4DC] group"
        data-testid={`article-list-${article.slug}`}
      >
        <div className="w-32 h-24 shrink-0 nv-zoom">
          <img src={coverFor(article)} alt={article.title} className="w-full h-full object-cover" draggable={false} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] font-bold tracking-[0.2em] uppercase text-[#2E7D32] mb-1">
            {CAT_NAMES[article.category]}
          </div>
          <h3 className="font-heading-te text-lg font-bold leading-snug group-hover:text-[#2E7D32] transition-colors line-clamp-2">
            {article.title}
          </h3>
          <div className="mt-1 text-xs text-[#4A4A4A]">{formatDate(article.created_at)}</div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block border border-[#E5E4DC] bg-white hover:border-[#2E7D32] transition-colors"
      data-testid={`article-card-${article.slug}`}
    >
      <div className="aspect-[16/10] overflow-hidden nv-zoom bg-gray-100">
        <img src={coverFor(article)} alt={article.title} className="w-full h-full object-cover" draggable={false} />
      </div>
      <div className="p-4">
        <div className="text-[10px] font-bold tracking-[0.2em] uppercase text-[#2E7D32] mb-2">
          {CAT_NAMES[article.category]}
        </div>
        <h3 className="font-heading-te text-xl font-bold leading-snug group-hover:text-[#2E7D32] transition-colors line-clamp-3">
          {article.title}
        </h3>
        {article.summary && (
          <p className="mt-2 font-body-te text-sm text-[#4A4A4A] line-clamp-2">{article.summary}</p>
        )}
        <div className="mt-3 text-xs text-[#4A4A4A]">{formatDate(article.created_at)}</div>
      </div>
    </Link>
  );
}
